import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const portalApi = axios.create({ baseURL: API });

portalApi.interceptors.request.use((config) => {
  const t = localStorage.getItem("portal_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

portalApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("portal_token");
      if (window.location.pathname.startsWith("/portal") && window.location.pathname !== "/portal/login") {
        window.location.href = "/portal/login";
      }
    }
    return Promise.reject(err);
  }
);

export default portalApi;
